import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, TemplateRef, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { EntityOrderedRequestParameters, EntityPagedRequestParameters } from "@bndes/bndes-ux4/bndes-angular-utils";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { InadimplenciaTecnica, TIPOS_BLOQUEIO } from "src/app/model/inadimplencia-tecnica.model";
import moment from "moment";
import { BnModalMessageService } from "@bndes/bndes-ux4/bn-modal-message";

@Component({
    selector: 'app-inadimplencia-listagem',
    templateUrl: './inadimplencia-listagem.component.html',
    styleUrls: ['inadimplencia-listagem.component.scss'],
    standalone: false
})
export class InadimplenciaListagemComponent{
  @Input() inadimplencias:InadimplenciaTecnica[];
  @Input() atributosPaginacao: EntityPagedRequestParameters;
  @Input() podeCadastrarInadimplencia:boolean;
  @Output() public aoMudarPagina: EventEmitter<EntityPagedRequestParameters> = new EventEmitter<EntityPagedRequestParameters>();
  private nomesAgentesFinanceiro:AgenteFinanceiro[] = [];
  public opcoesPaginacao: number[] = [10, 15, 20];
  public atributosOrdenacao: EntityOrderedRequestParameters;
  private dataHoraResultado: string;
  public dataHoraAtual: Date;
  private tiposBloqueio = TIPOS_BLOQUEIO;
  private idInadimplenciaExcluir: number;

  @Output() public exportarInadimplementos: EventEmitter<any> = new EventEmitter<any>();
  @Output() public excluirInadimplemento: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('msgTemplateExcluir') msgTemplateExcluir: TemplateRef<any>;
  @ViewChild('botoesPersonalizadosExcluir') botoesPersonalizadosExcluir: TemplateRef<any>;

  constructor(
    private activatedRoute:ActivatedRoute,
    private bnModalService: BnModalMessageService,
  ) {
    this.nomesAgentesFinanceiro = this.activatedRoute.snapshot.data['agentes'];
    this.dataHoraResultado = moment().format('YYYY-MM-DD HH:mm:ss');
    this.dataHoraAtual = moment().toDate();
  }

  ngOnInit() {
    if (!this.atributosOrdenacao){
      this.atributosOrdenacao = {
        atributo: '',
        sentido: 'asc'
      }
    }
  }

  mudancaPagina(novaPagina: EntityPagedRequestParameters) {
    this.atributosPaginacao = novaPagina;
    this.aoMudarPagina.emit(novaPagina);
  }

  mudancaOrdenacao(novaOrdenacao: EntityOrderedRequestParameters) {
    this.atributosOrdenacao = novaOrdenacao;
    this.pesquisarOrdenacao(this.atributosOrdenacao);
  }

  pesquisarOrdenacao(ord: EntityOrderedRequestParameters) {
      this.inadimplencias = this.inadimplencias.sort((a, b) => {
      if (ord.sentido == "asc") {
          return this.compara(a, b, ord.atributo);
      }
      else {
          return -1 * this.compara(a, b, ord.atributo);
      }
      });
  }

  private compara(a, b, atributo): number {
    if (this.fetchFromObject(a, atributo) == this.fetchFromObject(b, atributo)) {
      return 0;
    }
    else {
      if (this.fetchFromObject(a, atributo) > this.fetchFromObject(b, atributo)) {
        return 1;
      }
      else {
        return -1;
      }
    }
  }

  private fetchFromObject(obj, prop) {

    if(typeof obj === 'undefined') {
      return false;
    }

    var _index = prop.indexOf('.')
    if(_index > -1) {
        return this.fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }

    return obj[prop];
  }

  nomeAgenteFinanceiro(id:number){
      return  this.nomesAgentesFinanceiro
                  .filter( agente => Number(agente.id)==id)[0]?.nome;
  }

  labelTipoBloqueio(codigo: string) {
    const tipos = this.tiposBloqueio.filter(item => item.codigo == codigo);
    return tipos.length > 0 ? tipos[0].label : `Tipo de bloqueio para código '${codigo}' desconhecido.`;
  }

  btnExportarInadimplementos() {
    this.exportarInadimplementos.emit(null);
  }

  exibeEditar(data: Date) {
    return data === null || data === undefined || moment(data).isAfter(moment(this.dataHoraAtual));
  }

  permiteExcluir(inadimplencia: InadimplenciaTecnica) : boolean {
    return !inadimplencia.dataFim &&
      moment(inadimplencia.dataInicio).isAfter(moment(this.dataHoraAtual))
  }

  modalConfirmarExclusao(event: Event, id: number) {
    this.idInadimplenciaExcluir = id;
    event.stopPropagation();
    this.bnModalService.abrir(
      'Confirmação',
      'Esta ação irá EXCLUIR a linha selecionada. Você confirma?',
      'md',
      this.msgTemplateExcluir,
      this.botoesPersonalizadosExcluir
    );
  }

  excluir() {
    this.excluirInadimplemento.emit(this.idInadimplenciaExcluir);
    this.bnModalService.dismiss();
  }

  dismissModal() {
    this.bnModalService.dismiss();
  }

}